import { render, staticRenderFns } from "./ResultImage.vue?vue&type=template&id=a63f5452&scoped=true&lang=pug&"
import script from "./ResultImage.vue?vue&type=script&lang=js&"
export * from "./ResultImage.vue?vue&type=script&lang=js&"
import style0 from "./ResultImage.vue?vue&type=style&index=0&id=a63f5452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63f5452",
  null
  
)

export default component.exports